import clsx from 'clsx';
import type { LucideIcon } from 'lucide-react';
import styles from './Icon.module.css';

export type IconSize = 'sm' | 'md' | 'lg';

export interface IconProps {
  readonly icon: LucideIcon;
  readonly size?: IconSize | undefined;
  readonly className?: string | undefined;
  /** Only for icons that carry meaning on their own; decorative icons stay hidden from readers. */
  readonly label?: string | undefined;
}

/** The one way to draw an icon: a single set, token sizes, one stroke weight. */
export const Icon = ({ icon: Glyph, size = 'md', className, label }: IconProps) => (
  <Glyph
    className={clsx(styles.icon, styles[size], className)}
    aria-hidden={label ? undefined : true}
    aria-label={label}
    role={label ? 'img' : undefined}
    focusable="false"
  />
);
